import {
  TextIconButtonIcon,
  TextIconButtonRoot,
  TextIconButtonText,
} from './text-icon-button.parts';

export const TextIconButton = {
  Root: TextIconButtonRoot,
  Icon: TextIconButtonIcon,
  Text: TextIconButtonText,
};
